<div class="auth-layout">
<!--  <img class="circle" src="../../../../assets/images/123.png" alt="Circle">-->
<!--  <img class="cross" src="../../../../assets/images/12345.png" alt="Cross">-->
  <div class="auth-content">
    <router-outlet></router-outlet>
  </div>
</div>
